import { LogsLink, LogsTarget } from './logs-modal-constants';

// Each AWS Batch child prepares, solves, and pivots one optimizer iteration.
export const buildLogsLinks = (target: Omit<LogsTarget, 'status'>): LogsLink[] => [
  {
    label: 'Optimizer Iterations',
    href: `https://us-west-2.console.aws.amazon.com/cloudwatch/home?region=us-west-2#logEventViewer:group=/aws/batch/job;filter=%22OPTIMIZER-ITERATION-${target.kpi}-linear-${target.buildNumber}%22;start=${target.start};end=${target.end}`
  }
];
